import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=3f927c7b"
import script from "./RatingDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RatingDisplay.vue?vue&type=style&index=0&id=3f927c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports